import React, { useContext } from "react";
import { Core } from "../../components/infrastructure/core";
import { enmValidationLevel, IResultSet } from "../../components/infrastructure/models";
//import debounce from 'lodash/debounce';
import { Alert, Button, Form, Input, Radio, Tooltip } from "antd";
import { InfoCircleFilled, QuestionCircleFilled, WarningFilled } from '@ant-design/icons';
import { Redirect } from "react-router-dom";
import AppContext, { AppContextProps } from "../../components/infrastructure/appContext";
import { IPolicyEquipmentModel } from "../../baseInfo/policyEquipmentModel/interfaces";

interface InquiryPolicyStates {
    loading: boolean;
    equipmentType: "Mobile" | "Other";
    done?: boolean;
    isAuthorized: boolean;
    isAccessDenied?: boolean;
}

interface InquiryPolicyProps {
    onClose?: (policyEquipmentModel?: IPolicyEquipmentModel) => void;
}

//interface IEquipment {
//    name: string;
//    code: string;
//}

//interface IBrand {
//    name: string;
//    code: string;
//}

//interface IEquipmentModel {
//    name: string;
//    code: string;
//    equipmentCode: string;
//}

//interface IEquipmentStates {
//    loading: boolean;
//    selectedEquipmentCode?: string;
//    equipmentList: IEquipment[];
//}

//interface IBrandStates {
//    loading: boolean;
//    selectedBrandCode?: string;
//    brandList: IBrand[];
//}

//interface IEquipmentModelStates {
//    loading: boolean;
//    selectedEquipmentModelCode?: string;
//    equipmentModelList: IEquipmentModel[];
//}

export const InquiryPolicy = (props: InquiryPolicyProps) => {
    const { path, params, getUserInfo } = useContext<AppContextProps>(AppContext);
    const [state, setState] = React.useState<InquiryPolicyStates>({ loading: false, equipmentType: "Mobile", isAuthorized: true });
    const [form] = Form.useForm();
    const componentWillUnmount = React.useRef(false);

    const reset = () => {
        setState({ ...state, loading: false });
        if (props.onClose)
            props.onClose();
        else
            window.history.back();
    };

    const inquiry = async (values: any) => {
        if (state.loading)
            return;

        const imei1 = values['imei1'];
        const imei2 = values['imei2'];
        const equipmentSerialNo = values['equipmentSerialNo'];

        if (!equipmentSerialNo && !imei1 && !imei2) {
            Core.errorNotification('حداقل یکی از ورودی های سریال دستگاه یا IMEI1 یا IMEI2 اجباری است');
            return;
        }

        setState({ ...state, loading: true });

        let response = await fetch("api/portal/inquirypolicy", {
            method: 'POST',
            body: JSON.stringify({
                isMobile: state.equipmentType === "Mobile",
                imei1: state.equipmentType === "Mobile" ? values['imei1'] ?? null : null,
                imei2: state.equipmentType === "Mobile" ? values['imei2'] ?? null : null,
                equipmentSerialNo: state.equipmentType === "Other" ? values['equipmentSerialNo'] ?? null : null
            }),
            headers: { 'content-type': 'application/json;charset=UTF-8' }
        });

        if (componentWillUnmount.current === true)
            return;

        let result: IResultSet<any> = await response.json();

        const { ValidationResults } = result.ValidationState;
        if (!result.ValidationState.Successful) {
            if (ValidationResults.find(v => v.Level === enmValidationLevel.AccessDenied)) {
                Core.errorNotification(ValidationResults[0].Message!);
                setState({ ...state, isAccessDenied: true });
                return;
            }
            if (ValidationResults.find(v => v.Level === enmValidationLevel.Unauthorized)) {
                Core.errorNotification(ValidationResults[0].Message!);
                setState({ ...state, isAuthorized: false });
                return;
            }
            Core.errorNotification(ValidationResults[0].Message);
            setState({ ...state, loading: false, done: false });
        }
        else {
            for (let i = 0; i < ValidationResults.length; i++) {
                if (ValidationResults[i].Level === enmValidationLevel.Info)
                    Core.successNotification(ValidationResults[i].Message);
                else if (ValidationResults[i].Level === enmValidationLevel.Warning)
                    Core.warningNotification(ValidationResults[i].Message);
            }

            if (!ValidationResults.length) {
                Core.successNotification("استعلام بیمه نامه با موفقیت انجام شد");
                const userInfo = getUserInfo();
                if (userInfo) {
                    const { extraVariables } = userInfo;
                    if (!extraVariables["IsPolicyholder"]) {
                        setTimeout(() => {
                            document.location.replace('/');
                        }, 0)
                        return;
                    }
                }
            }
            if (props.onClose)
                props.onClose(result.Data);
            else
                setState({ ...state, loading: false, done: true });
        }
    };

    React.useEffect(() => {
        return () => {
            componentWillUnmount.current = true;
        };
    }, []);

    const mobileFieldsStyle = state.equipmentType === "Mobile" ? {} : { display: "none" };
    const otherFieldsStyle = state.equipmentType === "Mobile" ? { display: "none" } : {};

    if (!state.isAuthorized) {
        let returnUrl = '';
        const url = Core.getUrl(path, params);
        if (url !== '')
            returnUrl = '?returnUrl=' + url;
        return (<Redirect to={{ pathname: '/login', search: returnUrl }} />);
    }

    if (state.isAccessDenied === true)
        return (<Redirect to={'/'} />);

    if (state.done)
        return <Redirect to={"/policylist"} />;

    return (
        <div className="login-scroll" style={{ width: "100%", display: 'flex', textAlign: "center", justifyContent: "center", marginTop: 20 }}>
            <div className="col-xl-5 col-lg-6 col-md-8 col-sm-10 col-xs-10" style={{ margin: 10 }}>

                <Form
                    form={form}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 18 }}
                    name="normal_login"
                    className=" login-form col-sm-8 col-md-6 col-lg-6 col-xl-4 col-xs-8 "
                    initialValues={{ remember: true }}
                    onFinish={inquiry}
                    onReset={reset}
                    style={{ width: "calc(100% - 20px)", height: "100%", textAlign: 'right', margin: 10 }}
                >
                    <div className="box box-blue" style={{ backgroundColor: "#fefefe90", border: "1px solid white", borderRadius: 15 }}>
                        <div className="box-title" style={{ border: "1px solid white", borderTopLeftRadius: 15, borderTopRightRadius: 15 }}>
                            <div className="caption">استعلام بیمه نامه</div>
                        </div>

                        <div className="box-body form" style={{ border: "1px solid white", borderRadius: 15 }}>
                            <div className="form-body">

                                <Alert
                                    style={{ marginTop: 10, marginBottom: 20, textAlign: 'justify' }}
                                    message={"بیمه گزار/مشتری گرامی، جهت استعلام بیمه نامه، لطفا سریال دستگاه یا IMEI را وارد نمایید."}
                                    type="info"
                                    icon={<InfoCircleFilled className="blink" />}
                                    showIcon
                                />

                                <Radio.Group key={'equipmentType'} style={{ marginBottom: 10 }} onChange={e => setState({ ...state, equipmentType: e.target.value })} value={state.equipmentType}>
                                    <Radio key={'mobile'} value={"Mobile"}>
                                        <div>
                                            <span>استعلام بیمه نامه دستگاه موبایل</span>

                                        </div>
                                    </Radio>
                                    <Radio key={'other'} value={"Other"}>
                                        <div>
                                            <span>استعلام بیمه نامه دستگاه غیر موبایل</span>

                                        </div>
                                    </Radio>
                                </Radio.Group>

                                <Form.Item
                                    name="imei1"
                                    label="سریال IMEI1"
                                    style={mobileFieldsStyle}
                                    extra={
                                        <Tooltip title="سریال IMEI1 دستگاه موبایل" placement={"right"}>
                                            <Button icon={<QuestionCircleFilled style={{ transform: "scaleX(-1)" }} />} style={{ marginRight: 1, verticalAlign: 'top', position: "absolute", top: 0, left: 0, minHeight: 0 }} />
                                        </Tooltip>
                                    }
                                >
                                    <Input
                                        autoComplete="off"
                                        placeholder="سریال IMEI1 دستگاه موبایل"
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="imei2"
                                    label="سریال IMEI2"
                                    style={mobileFieldsStyle}
                                    extra={
                                        <Tooltip title="سریال IMEI2 دستگاه موبایل" placement={"right"}>
                                            <Button icon={<QuestionCircleFilled style={{ transform: "scaleX(-1)" }} />} style={{ marginRight: 1, verticalAlign: 'top', position: "absolute", top: 0, left: 0, minHeight: 0 }} />
                                        </Tooltip>
                                    }
                                >
                                    <Input
                                        autoComplete="off"
                                        placeholder="سریال IMEI2 دستگاه موبایل"
                                    />
                                </Form.Item>

                                <Form.Item
                                    name="equipmentSerialNo"
                                    label="سریال دستگاه"
                                    extra={
                                        <Tooltip title="سریال دستگاه غیر موبایل" placement={"right"}>
                                            <Button icon={<QuestionCircleFilled style={{ transform: "scaleX(-1)" }} />} style={{ marginRight: 1, verticalAlign: 'top', position: "absolute", top: 0, left: 0, minHeight: 0 }} />
                                        </Tooltip>
                                    }
                                    style={otherFieldsStyle}
                                >
                                    <Input
                                        autoComplete="off"
                                        placeholder="سریال دستگاه غیر موبایل"
                                    />
                                </Form.Item>

                                <Form.Item
                                    style={{ direction: 'ltr', textAlign: 'justify', marginTop: 10 }}
                                >
                                    <Button type="primary" htmlType="submit" className="login-form-button" loading={state.loading}>
                                        بررسی
                                    </Button>
                                    {
                                        props.onClose &&
                                        <Button type="default" htmlType="reset" className="login-form-button" loading={state.loading}>
                                            لغو
                                        </Button>
                                    }
                                    {
                                        !props.onClose &&
                                        <Button type="default" htmlType="reset" className="login-form-button" loading={state.loading}>
                                            برگشت
                                        </Button>
                                    }
                                </Form.Item>

                                {state.done === false && < Alert
                                    style={{ marginTop: 20, marginBottom: 10, textAlign: 'justify' }}
                                    message={
                                        <>
                                            بیمه گزار/مشتری گرامی، در صورت عدم دریافت و رؤیت بیمه نامه جهت ثبت خسارت، از طریق لینک  <b><a href="https://www.si24.ir/fa/services/form_Mobiledamage/add/template/defaultTemplate/swd_id/54504/" target="_blank" rel="noreferrer">"ثبت خسارت تجهیزات الکترونیک"</a></b> نسبت به ثبت خسارت اقدام نمایید. کارشناسان مربوطه ظرف مدت 72 ساعت کاری با شما تماس خواهند گرفت.
                                        </>
                                    }
                                    type="warning"
                                    icon={<WarningFilled className="blink" />}
                                    showIcon
                                />}

                            </div>
                        </div>
                    </div>

                </Form>
            </div>
        </div>
    );
}